export const AUTHORIZE_PATH = '/authorize';
export const CHANGE_PASSWORD_PATH = '/change-password';
export const CLI_LOGIN_CANCELED_PATH = '/cli-login-canceled';
export const CLI_LOGIN_PATH = '/cli-login';
export const CLI_LOGIN_SUCCESS_PATH = '/cli-login-success';
export const LOGIN_PATH = '/login';
export const LOGIN_REDIRECT_PATH = '/login-redirect';
export const LOGOUT_PATH = '/logout';
